// extracted by mini-css-extract-plugin
export var menuIcon = "_q7-0";
export var menuIconInline = "_q7-1";